export default __webpack_public_path__ + "static/media/sd.d94252fd.svg";